import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditsList = ({ audits, onViewAudit, onEditAudit, onPublishAudit, onDeleteAudit }) => {
  const getStatusColor = (status) => {
    const colors = {
      draft: 'bg-gray-500/10 text-gray-700 border-gray-200',
      active: 'bg-green-500/10 text-green-700 border-green-200',
      completed: 'bg-blue-500/10 text-blue-700 border-blue-200'
    };
    return colors?.[status] || colors?.draft;
  };

  const getStatusIcon = (status) => {
    const icons = {
      draft: 'FileEdit',
      active: 'Activity',
      completed: 'CheckCircle'
    };
    return icons?.[status] || 'FileText';
  };

  return (
    <div className="space-y-4">
      {audits?.map((audit) => (
        <div
          key={audit?.id}
          className="bg-card border border-border rounded-lg p-6 hover:shadow-md transition-shadow"
        >
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-2">
                <h3 className="text-lg font-semibold text-foreground">{audit?.title}</h3>
                <span className={`px-3 py-1 rounded-full text-xs font-medium border ${getStatusColor(audit?.status)}`}>
                  <Icon name={getStatusIcon(audit?.status)} size={12} className="inline mr-1" />
                  {audit?.status?.charAt(0)?.toUpperCase() + audit?.status?.slice(1)}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mb-3">{audit?.description}</p>
              
              <div className="flex flex-wrap gap-4 text-sm text-muted-foreground">
                <div className="flex items-center gap-1">
                  <Icon name="MapPin" size={14} />
                  <span>{audit?.location}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="Calendar" size={14} />
                  <span>Due: {audit?.dueDate}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="FileQuestion" size={14} />
                  <span>{audit?.totalQuestions} Questions</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="Users" size={14} />
                  <span>{audit?.completedUsers}/{audit?.totalUsers} Completed</span>
                </div>
              </div>
            </div>
          </div>

          {/* Progress Bar */}
          {audit?.status !== 'draft' && (
            <div className="mb-4">
              <div className="flex items-center justify-between text-xs text-muted-foreground mb-1">
                <span>Response Rate</span>
                <span className="font-medium">{audit?.responseRate}%</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div
                  className="bg-primary h-2 rounded-full transition-all"
                  style={{ width: `${audit?.responseRate}%` }}
                />
              </div>
            </div>
          )}

          {/* Question Banks */}
          <div className="flex flex-wrap gap-2 mb-4">
            {audit?.questionBanks?.map((bank, index) => (
              <span
                key={index}
                className="px-2 py-1 bg-muted text-xs text-foreground rounded"
              >
                {bank}
              </span>
            ))}
          </div>

          {/* Actions */}
          <div className="flex flex-wrap gap-2 pt-4 border-t border-border">
            <button
              onClick={() => onViewAudit(audit?.id)}
              className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 transition-colors text-sm font-medium"
            >
              <Icon name="Eye" size={16} />
              View Responses
            </button>

            {audit?.status === 'draft' && (
              <>
                <button
                  onClick={() => onEditAudit(audit?.id)}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm font-medium"
                >
                  <Icon name="Edit" size={16} />
                  Edit
                </button>
                <button
                  onClick={() => onPublishAudit(audit?.id)}
                  className="inline-flex items-center gap-2 px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors text-sm font-medium"
                >
                  <Icon name="Send" size={16} />
                  Publish
                </button>
              </>
            )}

            {audit?.status === 'active' && (
              <button
                onClick={() => onEditAudit(audit?.id)}
                className="inline-flex items-center gap-2 px-4 py-2 bg-muted text-foreground rounded-lg hover:bg-muted/80 transition-colors text-sm font-medium"
              >
                <Icon name="Settings" size={16} />
                Manage
              </button>
            )}

            <button
              onClick={() => onDeleteAudit(audit?.id)}
              className="inline-flex items-center gap-2 px-4 py-2 bg-red-500/10 text-red-600 rounded-lg hover:bg-red-500/20 transition-colors text-sm font-medium ml-auto"
            >
              <Icon name="Trash2" size={16} />
              Delete
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AuditsList;